export default "__VITE_ASSET__BRiZjznC__"